export default function(appId) {
  const picnicScript = document.getElementById('picnic_team_script')
  if (!picnicScript.dataset.site) {
    console.warn('Picnic Site ID missing')
  }
  const picnicDiv = document.createElement('div')
  picnicDiv.id = appId
  picnicDiv.className = appId
  picnicDiv.setAttribute('data-picnic-element', '')
  picnicDiv.innerHTML = `<app></app>`
  document.body.appendChild(picnicDiv)

  return picnicScript.dataset.site
}
